import React from "react";
import "./BlogDetailedPage.scss"
import fb from "../assets/fb.svg"
import linkedin from "../assets/linkedin.svg"
import twitter from "../assets/twitter.svg"
import moment from "moment";

const BlogDetailedPage = ({ blog }) => {
    const BlogText = ({ text, color = "", padding, margin }) => {
        return (
            <div className="Blog-content"
                dangerouslySetInnerHTML={{ __html: text }}
                style={{
                    color,
                    paddingTop: padding?.top ?? "",
                    paddingBottom: padding?.bottom ?? "",
                    paddingLeft: padding?.left ?? "",
                    paddingRight: padding?.right ?? "",
                    marginTop: margin?.top ?? "",
                    marginBottom: margin?.bottom ?? "",
                    marginLeft: margin?.left ?? "",
                    marginRight: margin?.top ?? "",
                }} />
        )
    }
    const BlogQuote = ({ text, color = "", padding, margin }) => {
        return (
            <div className="Blog-quote"
                style={{
                    color,
                    paddingTop: padding?.top ?? "",
                    paddingBottom: padding?.bottom ?? "",
                    paddingLeft: padding?.left ?? "",
                    paddingRight: padding?.right ?? "",
                    marginTop: margin?.top ?? "",
                    marginBottom: margin?.bottom ?? "",
                    marginLeft: margin?.left ?? "",
                    marginRight: margin?.top ?? "",
                }}>"{text}"</div>
        )
    }
    const BlogHeader = ({ text, color = "", padding, margin }) => {
        return (
            <div className="Blog-header"
                dangerouslySetInnerHTML={{ __html: text }}
                style={{
                    color,
                    paddingTop: padding?.top ?? "",
                    paddingBottom: padding?.bottom ?? "",
                    paddingLeft: padding?.left ?? "",
                    paddingRight: padding?.right ?? "",
                    marginTop: margin?.top ?? "",
                    marginBottom: margin?.bottom ?? "",
                    marginLeft: margin?.left ?? "",
                    marginRight: margin?.top ?? "",
                }} />
        )
    }
    const BlogButton = ({ text, link, opneNewTab, padding, margin }) => {
        return (
            <div className="Blog-button"
                onClick={() => {
                    if (opneNewTab) {
                        window.open(link, '_blank')
                    } else {
                        window.location.href = link
                    }
                }}
                style={{
                    paddingTop: padding?.top ?? "",
                    paddingBottom: padding?.bottom ?? "",
                    paddingLeft: padding?.left ?? "",
                    paddingRight: padding?.right ?? "",
                    marginTop: margin?.top ?? "",
                    marginBottom: margin?.bottom ?? "",
                    marginLeft: margin?.left ?? "",
                    marginRight: margin?.top ?? "",
                }}>{text}</div>
        )
    }
    const BlogImage = ({ url, height, padding, margin }) => {
        return (
            <img className="Blog-image" alt="" src={url}
                style={{
                    height,
                    paddingTop: padding?.top ?? "",
                    paddingBottom: padding?.bottom ?? "",
                    paddingLeft: padding?.left ?? "",
                    paddingRight: padding?.right ?? "",
                    marginTop: margin?.top ?? "",
                    marginBottom: margin?.bottom ?? "",
                    marginLeft: margin?.left ?? "",
                    marginRight: margin?.top ?? "",
                }} />
        )
    }
    const BlogGallery = ({ images, padding, margin }) => {
        return (
            <div className="Blog-gallery"
                style={{
                    paddingTop: padding?.top ?? "",
                    paddingBottom: padding?.bottom ?? "",
                    paddingLeft: padding?.left ?? "",
                    paddingRight: padding?.right ?? "",
                    marginTop: margin?.top ?? "",
                    marginBottom: margin?.bottom ?? "",
                    marginLeft: margin?.left ?? "",
                    marginRight: margin?.top ?? "",
                }}>
                {images?.map((item, key) => {
                    return (
                        <img alt={item?.alt} src={item?.url} key={key}
                            className="Blog-gallery-image" />
                    )
                })}
            </div>
        )
    }
    const BlogColumn = ({ columns, gap, padding, margin }) => {
        return (
            <div className="Blog-column"
                style={{
                    gap,
                    paddingTop: padding?.top ?? "",
                    paddingBottom: padding?.bottom ?? "",
                    paddingLeft: padding?.left ?? "",
                    paddingRight: padding?.right ?? "",
                    marginTop: margin?.top ?? "",
                    marginBottom: margin?.bottom ?? "",
                    marginLeft: margin?.left ?? "",
                    marginRight: margin?.top ?? "",
                }}>
                {columns?.map((column) => {
                    return (<div style={{ width: column?.width }}>
                        {sortByOrderAscending(column?.blocks).map((component, key) => {
                            return (getContent(component))
                        })}
                    </div>)
                })}
            </div>
        )
    }
    // let blog = {
    //     "website_id": "507f1f77bcf86cd799439011",
    //     "title": "10 Best Indian Dishes You Must Try in Staines",
    //     "slug": "best-indian-dishes-staines",
    //     "excerpt": "Discover the most authentic and delicious Indian cuisine in Staines. From traditional kababs to modern fusion dishes.",
    //     "hero": {
    //         "type": "image",
    //         "background_image": "https://media.istockphoto.com/id/1397973112/photo/assortment-of-various-kinds-of-indian-cousine-on-dark-rusty-table.jpg?s=612x612&w=0&k=20&c=R5XnXgP1jWnGM5PF7OUfvLW_NQhAcaGuJlWp6hl0SoQ=",
    //         "overlay": {
    //             "enabled": true,
    //             "color": "#000000",
    //             "opacity": 0.4
    //         },
    //         "height": "large",
    //         "alignment": "center"
    //     },
    //     "content_blocks":
    //         [
    //             {
    //                 "id": "block_1",
    //                 "type": "text",
    //                 "order": 1,
    //                 "content": {
    //                     "html": "The sizzle of marinated meats meeting the searing heat of a clay oven, the intoxicating aroma of spices filling the air—this is the magic of the tandoor. At Virasat, we honor this ancient cooking method, a cornerstone of North Indian cuisine that dates back centuries. It is more than just a cooking technique; it's a culinary ritual that transforms simple ingredients into masterpieces of flavor and texture.",
    //                 },
    //                 "style": {
    //                     "text_color": "#2C3E50",
    //                     "padding": {
    //                         "top": 20,
    //                         "bottom": 10,
    //                         "left": 0,
    //                         "right": 0
    //                     }
    //                 }
    //             },
    //             {
    //                 "id": "block_2",
    //                 "type": "text",
    //                 "order": 2,
    //                 "content": {
    //                     "html": "The tandoor, a cylindrical clay oven, is a marvel of simple engineering. Fired by charcoal or wood, it can reach temperatures of up to 900°F (480°C). This intense, dry heat cooks food rapidly, sealing in juices and creating a characteristic smoky char on the outside while keeping the inside incredibly moist and tender. This unique cooking environment is what gives dishes like Tandoori Chicken its vibrant red hue and succulent bite, and what makes our naan bread perfectly crisp on the outside and pillowy-soft within.",
    //                 },
    //                 "style": {
    //                     "text_color": "#2C3E50",
    //                     "padding": {
    //                         "top": 20,
    //                         "bottom": 10,
    //                         "left": 0,
    //                         "right": 0
    //                     }
    //                 }
    //             },
    //             {
    //                 "id": "block_3",
    //                 "type": "quote",
    //                 "order": 3,
    //                 "content": {
    //                     "text": "The tandoor is the heart of our kitchen. It represents a connection to our heritage, a tradition passed down through generations that we are proud to share with every guest.",
    //                 },
    //                 "style": {
    //                     "text_color": "#2C3E50",
    //                     "padding": {
    //                         "top": 20,
    //                         "bottom": 10,
    //                         "left": 0,
    //                         "right": 0
    //                     }
    //                 }
    //             },
    //             {
    //                 "id": "block_4",
    //                 "type": "header",
    //                 "order": 4,
    //                 "content": {
    //                     "html": "The Art of the Marinade"
    //                 },
    //                 "style": {
    //                     "text_color": "#2C3E50",
    //                     "padding": {
    //                         "top": 20,
    //                         "bottom": 10,
    //                         "left": 0,
    //                         "right": 0
    //                     }
    //                 }
    //             },
    //             {
    //                 "id": "block_5",
    //                 "type": "text",
    //                 "order": 5,
    //                 "content": {
    //                     "html": "Before any ingredient meets the tandoor's heat, it undergoes a crucial preparation: the marinade. A blend of yogurt, ginger, garlic, and a symphony of spices like garam masala, turmeric, and cumin not only tenderizes the meat but also infuses it with layers of complex flavor. This process can last for hours, allowing the spices to penetrate deeply, ensuring that every bite is a burst of authentic Indian taste. It is this patient preparation that sets tandoori dishes apart.",
    //                 },
    //                 "style": {
    //                     "text_color": "#2C3E50",
    //                     "padding": {
    //                         "top": 20,
    //                         "bottom": 10,
    //                         "left": 0,
    //                         "right": 0
    //                     }
    //                 }
    //             },
    //             {
    //                 "id": "block_6",
    //                 "type": "text",
    //                 "order": 6,
    //                 "content": {
    //                     "html": "From the classic Chicken Tikka to succulent Lamb Seekh Kebabs and flavorful Paneer Tikka for our vegetarian guests, the tandoor's versatility is boundless. We invite you to explore our menu and experience the timeless tradition of tandoori cooking—a true taste of Virasat's heritage.",
    //                 },
    //                 "style": {
    //                     "text_color": "#2C3E50",
    //                     "padding": {
    //                         "top": 20,
    //                         "bottom": 10,
    //                         "left": 0,
    //                         "right": 0
    //                     }
    //                 }
    //             },
    //             {
    //                 "id": "block_7",
    //                 "type": "button",
    //                 "order": 7,
    //                 "content": {
    //                     "text": "Order Now",
    //                     "link": "https://www.virasat.uk/order",
    //                     "open_new_tab": false,
    //                     "style": "primary",
    //                     "size": "large",
    //                     "icon": "shopping-cart",
    //                     "icon_position": "right"
    //                 },
    //                 "style": {
    //                     "alignment": "center",
    //                     "margin": {
    //                         "top": 60,
    //                         "bottom": 60,
    //                         "left": 0,
    //                         "right": 0
    //                     }
    //                 }
    //             },
    //             {
    //                 "id": "block_8",
    //                 "type": "gallery",
    //                 "order": 8,
    //                 "content": {
    //                     "images": [
    //                         {
    //                             "url": "https://images.unsplash.com/photo-1640625314547-aee9a7696589?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8bmFhbnxlbnwwfHwwfHx8MA%3D%3D",
    //                             "alt": "Butter Naan",
    //                             "width": 800,
    //                             "height": 600,
    //                             "mime_type": "image/jpeg"
    //                         },
    //                         {
    //                             "url": "https://plus.unsplash.com/premium_photo-1695297516676-04a259917c03?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8c2Ftb3NhfGVufDB8fDB8fHww",
    //                             "alt": "Crispy Samosas",
    //                             "width": 800,
    //                             "height": 600,
    //                             "mime_type": "image/jpeg"
    //                         },
    //                         {
    //                             "url": "https://images.unsplash.com/photo-1631452180519-c014fe946bc7?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8cGFuZWVyJTIwdGlra2F8ZW58MHx8MHx8fDA%3D",
    //                             "alt": "Paneer Tikka",
    //                             "width": 800,
    //                             "height": 600,
    //                             "mime_type": "image/jpeg"
    //                         },
    //                         {
    //                             "url": "https://www.funfoodfrolic.com/wp-content/uploads/2023/04/Dal-Makhani-Blog.jpg",
    //                             "alt": "Dal Makhani",
    //                             "width": 800,
    //                             "height": 600,
    //                             "mime_type": "image/jpeg"
    //                         }
    //                     ],
    //                     "layout": "grid",
    //                     "columns": 2,
    //                     "gap": 20,
    //                     "lightbox": true,
    //                     "show_captions": true
    //                 },
    //                 "style": {
    //                     "margin": {
    //                         "top": 60,
    //                         "bottom": 60,
    //                         "left": 0,
    //                         "right": 0
    //                     }
    //                 }
    //             },
    //             {
    //                 "id": "block_9",
    //                 "type": "image",
    //                 "order": 9,
    //                 "content": {
    //                     "image": {
    //                         "url": "https://media.istockphoto.com/id/1397973112/photo/assortment-of-various-kinds-of-indian-cousine-on-dark-rusty-table.jpg?s=612x612&w=0&k=20&c=R5XnXgP1jWnGM5PF7OUfvLW_NQhAcaGuJlWp6hl0SoQ=",
    //                         "alt": "Chicken Biryani",
    //                         "width": 600,
    //                         "height": 400,
    //                         "mime_type": "image/jpeg"
    //                     },
    //                     "size": "full",
    //                     "position": "center"
    //                 }
    //             },
    //             {
    //                 "id": "block_10",
    //                 "type": "columns",
    //                 "order": 10,
    //                 "content": {
    //                     "columns": [
    //                         {
    //                             "width": "50%",
    //                             "blocks": [
    //                                 {
    //                                     "id": "col1_block1",
    //                                     "type": "image",
    //                                     "order": 1,
    //                                     "content": {
    //                                         "image": {
    //                                             "url": "https://www.licious.in/blog/wp-content/uploads/2022/06/chicken-hyderabadi-biryani-01.jpg",
    //                                             "alt": "Chicken Biryani",
    //                                             "width": 600,
    //                                             "height": 400,
    //                                             "mime_type": "image/jpeg"
    //                                         },
    //                                         "size": "full",
    //                                         "position": "center"
    //                                     }
    //                                 }
    //                             ]
    //                         },
    //                         {
    //                             "width": "50%",
    //                             "blocks": [
    //                                 {
    //                                     "id": "col2_block1",
    //                                     "type": "text",
    //                                     "order": 1,
    //                                     "content": {
    //                                         "html": "Aromatic basmati rice layered with tender chicken pieces, slow-cooked with exotic spices. A must-try dish that represents the heart of Indian cuisine",
    //                                         "format": "paragraph"
    //                                     },
    //                                     "style": {
    //                                         "padding": {
    //                                             "top": 0,
    //                                             "right": 0,
    //                                             "bottom": 0,
    //                                             "left": 30
    //                                         }
    //                                     }
    //                                 }
    //                             ]
    //                         }
    //                     ],
    //                     "gap": 40,
    //                     "stack_on_mobile": true
    //                 },
    //                 "style": {
    //                     "margin": {
    //                         "top": 40,
    //                         "bottom": 40,
    //                         "left": 0,
    //                         "right": 0
    //                     }
    //                 }
    //             },
    //         ],
    //     "author_id": "507f1f77bcf86cd799439012",
    //     "author_name": "Chef Rajesh Kumar",
    //     "author_image": "https://storage.googleapis.com/eco_image/team/chef-rajesh.jpg",
    //     "seo": {
    //         "title": "10 Best Indian Dishes You Must Try in Staines | Virasat Restaurant",
    //         "meta_description": "Discover the most authentic Indian dishes in Staines. From tandoori chicken to biryani, explore the flavors of India at Virasat Restaurant.",
    //         "meta_keywords": ["indian food staines", "best indian restaurant", "tandoori chicken", "biryani", "virasat staines"],
    //         "robots": "index, follow",
    //         "canonical_url": "https://www.virasat.uk/blog/best-indian-dishes-staines",
    //         "og_type": "article",
    //         "og_url": "https://www.virasat.uk/blog/best-indian-dishes-staines",
    //         "og_title": "10 Best Indian Dishes You Must Try in Staines",
    //         "og_description": "Discover the most authentic Indian dishes in Staines. From tandoori chicken to biryani, explore the flavors of India.",
    //         "og_image": "https://storage.googleapis.com/eco_image/blogs/hero-indian-food.jpg",
    //         "og_site_name": "Virasat",
    //         "twitter_card": "summary_large_image",
    //         "twitter_url": "https://www.virasat.uk/blog/best-indian-dishes-staines",
    //         "twitter_title": "10 Best Indian Dishes You Must Try in Staines",
    //         "twitter_description": "Discover the most authentic Indian dishes in Staines.",
    //         "twitter_image": "https://storage.googleapis.com/eco_image/blogs/hero-indian-food.jpg",
    //         "google_analytics_id": "G-8EMWY8SSER",
    //         "schema_type": "BlogPosting"
    //     },
    //     "layout": {
    //         "template": "default",
    //         "max_width": 1200,
    //         "sidebar": {
    //             "enabled": true,
    //             "position": "right",
    //             "width": 30,
    //             "sticky": true,
    //             "widgets": ["recent_posts", "categories", "newsletter"]
    //         }
    //     },
    //     "theme": {
    //         "primary_color": "#D4AF37",
    //         "secondary_color": "#8B4513",
    //         "text_color": "#333333",
    //         "background_color": "#FFFFFF",
    //         "font_family": "Inter, sans-serif",
    //         "heading_font": "Playfair Display, serif"
    //     },
    //     "categories": ["Indian Cuisine", "Restaurant Reviews"],
    //     "tags": ["tandoori", "biryani", "staines", "indian food"],
    //     "status": "published",
    //     "published_at": "2024-11-15T10:00:00Z"
    // }
    const getContent = (block) => {
        switch (block.type) {
            case "text":
                return <BlogText
                    text={block?.content?.html}
                    color={block?.style?.text_color}
                    padding={block?.style?.padding}
                    margin={block?.style?.margin} />

            case "header":
                return <BlogHeader
                    text={block?.content?.html}
                    color={block?.style?.text_color}
                    padding={block?.style?.padding}
                    margin={block?.style?.margin} />
            case "quote":
                return <BlogQuote
                    text={block?.content?.text}
                    color={block?.style?.text_color}
                    padding={block?.style?.padding}
                    margin={block?.style?.margin} />
            case "button":
                return <BlogButton
                    text={block?.content?.text}
                    link={block?.content?.link}
                    opneNewTab={block?.content?.open_new_tab}
                    padding={block?.style?.padding}
                    margin={block?.style?.margin} />
            case "gallery":
                return <BlogGallery
                    images={block?.content?.images}
                    padding={block?.style?.padding}
                    margin={block?.style?.margin} />
            case "image":
                return <BlogImage
                    url={block?.content?.image?.url}
                    padding={block?.style?.padding}
                    margin={block?.style?.margin} />
            case "columns":
                return <BlogColumn
                    columns={block?.content?.columns}
                    gap={block?.content?.gap}
                    padding={block?.style?.padding}
                    margin={block?.style?.margin} />
            default:
                return <BlogText
                    text={block?.content?.html}
                    color={block?.style?.text_color}
                    padding={block?.style?.padding}
                    margin={block?.style?.margin} />
        }

    }
    const sortByOrderAscending = (components) => {
        return [...components]?.sort((a, b) => a.order - b.order);
    }
    return (
        <div className="BlogDetailedPage">
            <div className="BlogDetailedPage-title">Our Culinary Journey</div>
            <div className="BlogDetailedPage-header">{blog?.title}</div>
            <div className="BlogDetailedPage-detail">
                <div>By {blog?.author_name}</div>
                <div className="BlogDetailedPage-detail-dot">•</div>
                <div>{moment(blog?.published_at).format("MMMM DD, YYYY")}</div>
            </div>
            <img alt="" src={blog?.hero?.background_image}
                className="BlogDetailedPage-image" />
            <div className="BlogDetailedPage-container">
                {/* <div className="BlogDetailedPage-container-left">
                    <div className="Blog-share">Share</div>
                    <div className="Blog-social"><img alt="" src={twitter} /></div>
                    <div className="Blog-social"><img alt="" src={fb} /></div>
                    <div className="Blog-social"><img alt="" src={linkedin} /></div>


                </div> */}
                <div className="BlogDetailedPage-container-right">
                    {blog?.content_blocks && sortByOrderAscending(blog?.content_blocks)?.map((component, key) => {
                        return (getContent(component))
                    })} </div>
            </div>


        </div>
    )
}
export default BlogDetailedPage